import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { FormTemplate } from 'app/models/template';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { FormTemplateService } from 'app/services/form-template.service';
import { UserService } from 'app/services/user.service';
import { finalize } from 'rxjs/operators';
import { FormFillerComponent } from '../form-filler/form-filler.component';

@Component({
  selector: 'app-deleted-forms',
  templateUrl: './deleted-forms.component.html',
  styleUrls: ['./deleted-forms.component.scss']
})
export class DeletedFormsComponent implements OnInit {

  unFilteredDeletedForms: FormTemplate[] = [];
  deletedForms: FormTemplate[] = [];

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedTableLimit = 5;
  tableLoadingIndicator: boolean = true;

  formsFilter: string = '';
  pathToRestore: string = '';

  @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;
  @ViewChild('formFiller') formFiller: FormFillerComponent;

  constructor(private formTemplateService: FormTemplateService,
              private ecoDocsTitleService: EcoDocsTitleService,
              public userService: UserService) { }

  ngOnInit(): void {
    this.ecoDocsTitleService.setTitle( 'Deleted Forms', false );

    this.refreshTable();
  }

  refreshTable() {
    this.tableLoadingIndicator = true;
    this.formTemplateService.listDeleted().subscribe((f) => {
      this.deletedForms = f;
      this.unFilteredDeletedForms = f;
      this.updateFilter();
      this.tableLoadingIndicator = false;
    });    
  }

  restorePath() {
    this.tableLoadingIndicator = true;
    this.formTemplateService.restoreForm(this.pathToRestore).subscribe(() => {
      this.tableLoadingIndicator = false;
      this.refreshTable();
      this.pathToRestore = '';
    });
  }

  viewForm(formTemplate: FormTemplate) {
    this.tableLoadingIndicator = true;
    this.formTemplateService.getById(formTemplate.id).pipe(finalize(() => {
      this.tableLoadingIndicator = false;
    })).subscribe((f) => {
      this.formFiller.show(f, null, null, null, null, true, true);
    });
  }

  updateFilter() {
    // filter our data
    const temp = this.unFilteredDeletedForms.filter((form: FormTemplate) => {

      return (this.formsFilter.length == 0 || form.path.toLowerCase().indexOf(this.formsFilter.toLowerCase()) != -1);
    });

    // update the rows
    this.deletedForms = temp;

    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  innerWidth() {
    return window.innerWidth;
  }

}
